import React from 'react'
import { CopyToClipboard } from 'scenes/Dashboard/components/Utils/CopyToClipBoard.component'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

export type DealCardFitUrlProps = {
  className?: string
  fitUrl: string
}

function printSplittedFitUrls(fitUrls: string): JSX.Element[] {
  const arrayOfFitUrls = fitUrls.split(/[,\s]/).filter((url) => !!url)
  return arrayOfFitUrls.map((url, index) => {
    return (
      <li key={`${index}-${url}`}>
        <a href={`${url}`} target="_blank" rel="noreferrer">
          {url}
        </a>
      </li>
    )
  })
}

export const DealCardFitUrl = React.memo(({ className, fitUrl }: DealCardFitUrlProps) => {
  const { classes } = useStyles()
  return (
    <div className={className}>
      <Typography className={classes.title} variant="body1">
        <div>
          Fit url
          <CopyToClipboard
            textToCopy={fitUrl}
            className={classes.clipBoard}
            tooltipText={'Copy Fit Url to clipboard'}
          ></CopyToClipboard>
        </div>
      </Typography>
      <Typography variant="body1" className={classes.fitUrls}>
        {fitUrl.includes('http') && <ul>{printSplittedFitUrls(fitUrl)}</ul>}

        {!fitUrl.includes('http') && <span>{fitUrl}</span>}
      </Typography>
    </div>
  )
})

DealCardFitUrl.displayName = 'DealCardFitUrl'

const useStyles = makeStyles()(({ typography }: Theme) => ({
  fitUrls: {
    whiteSpace: 'pre-line',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    hyphens: 'auto',
  },
  title: {
    marginTop: '8 px',
    fontWeight: typography.fontWeightBold,
  },
  clipBoard: {
    fontWeight: typography.fontWeightBold,
  },
}))
